import { Map } from 'immutable';
import actions from './actions';
import { disconnectFromWebSocketsChannels } from '../../helpers/socket';

const initJson = {
  is2faRequired:false,
  redirectAfterLoginUrl:undefined,
  currentUser:undefined,
  loadingApp: false
};
const initState = new Map(initJson);

export default function authReducer(state = initState, action) {
  const authState = state.toJS();

  switch (action.type) {
    //------------------ log in/out stuff
    case actions.LOGOUT:
      // this is not the best place to put it....
      const webSocketConnection = authState.webSocketConnection;
      const currentUser = authState.currentUser;
      if (currentUser) disconnectFromWebSocketsChannels(webSocketConnection, currentUser.id);
      return new Map({
        ...initJson
      });
    case actions.LOGIN_REQUEST:
    case actions.LOGIN_WITH_OTP_REQUEST:
      return new Map({
        ...authState,
        loadingApp: true,
        is2faRequired:false,
      });
    case actions.LOGIN_REQUIRES_OTP:
      return new Map({
        ...authState,
        loadingApp: false,
        is2faRequired:true
      });
    case actions.LOGIN_SUCCESS:
      return new Map({
        ...authState,
        currentUser:action.currentUser,
        webSocketConnection:action.webSocketConnection
      });
    case actions.SET_REDIRECT_AFTER_LOGIN:
      return new Map({
        ...authState,
        redirectAfterLoginUrl: action.redirectAfterLoginUrl
      });    
    case actions.LOGIN_ERROR:
      return new Map({
        ...initJson,
        loadingApp: false
      });


    default:
      return state;
  }
}
